import FORBIDDEN_WORDS from '../config/constants/forbiddenWords.json';

const isProfane = (text: string) =>
    FORBIDDEN_WORDS.words.filter((word) => {
        const wordExp = new RegExp(`\\b${word.replace(/(\W)/g, '\\$1')}\\b`, 'gi');
        return wordExp.test(text);
    }).length > 0 ||
    !!FORBIDDEN_WORDS.words.find((word) => text.includes(word)) ||
    false;

export default isProfane;
